export const filterUndefined = (record: Record<string, any>) => {
    const updatedRecord: Record<string, any> = {}
    Object.entries(record).forEach(([key, value]) => {
        if (typeof value !== "undefined") {
            updatedRecord[key] = value;
        }
    })

    return updatedRecord;
}
